<template>
  <div class="autocomplete-item">
    {{item.name}}<span v-if="item.stateName" class="autocomplete-item-state"> {{item.stateName}}</span><span v-if="item.country" class="autocomplete-item-country">, {{$t('countries.' + item.country)}}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true }
  }
}
</script>